import { Button } from 'react-bootstrap';
import './FilterChip.scss';
import React, { ReactNode } from 'react';
import { IoMdClose } from 'react-icons/io';
import classNames from 'classnames';

export interface FilterChipProps {
  bg?: string;
  label: string;
  text: ReactNode;
  onDelete?: () => void;
  disableDelete?: boolean;
}

const FilterChip: React.FC<FilterChipProps> = ({ bg, label, text, onDelete, disableDelete = false }) => {
  return (
    <div
      className={classNames(
        'filter-chip',
        bg ? `bg-${bg}-light` : 'bg-light',
        `rounded-pill text-body d-flex align-items-center gap-2`
      )}>
      <span className="fw-bold text-capitalize text-nowrap">{label}:</span>
      <span className="text-nowrap">{text}</span>
      {!disableDelete && (
        <Button
          variant={bg ? `outline-${bg}` : 'outline-dark'}
          className="filter-close-btn border-0 p-0 rounded-circle d-flex align-items-center justify-content-center"
          onClick={() => onDelete()}>
          <IoMdClose size={20} />
        </Button>
      )}
    </div>
  );
};

export default FilterChip;
